"use client";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Image from "next/image";
// import dataSet from "@/data/projects";

const ProjectSlider = ({ projects }) => {
  if(!projects || projects.length === 0) {
    return null;
  }
  const filterProjects = projects.filter((project) => project.pin);
  const settings = {
    infinite: true,
    centerMode: true,
    centerPadding: "200px",
    speed: 500,
    focusOnSelect: true,
    dots: true,
    swipeToSlide: true,
    slidesToShow: 1, // 👈 default สำหรับ desktop
    arrows: false,

    responsive: [
      {
        breakpoint: 1280, // ⬅️ เริ่มลดขนาดจากจอใหญ่
        settings: {
          slidesToShow: 1,
          centerPadding: "100px",
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "30px",
          arrows: false,
        },
      }
      
    ],
  };

  return (
    <main className="main_ourwork_sub">
      <div className="container_ourwork">
        <div className="sliderwrapper">
          <PhotoProvider>
            <Slider {...settings}>
              {/* {(filterProjects || []).slice(0, 2).map((data) => ( */}
              {(filterProjects || []).map((data) => (
                <div key={data.id} className="cardWithPhoto">
                  <div className="backgroundLayer">
                    {/* <PhotoView src={data.coverImage?.url}> */}
                    <Image
                      src={data.coverImage?.url}
                      fill
                      quality={80}
                      alt={data.description || "Gallery Image"}
                      onContextMenu={(e) => e.preventDefault()}
                      // blurDataURL="/placeholder.jpg"
                    />
                    {/* </PhotoView> */}
                  </div>
                  <div className="content">
                    <div className="contentHeader">
                      <div className="flex items-center text-white">
                        <img
                          src="/maps-icon.svg"
                          width={16}
                          height={16}
                          quality={70}
                          alt="Location Icon"
                          className="locationIcon"
                        />
                        <h3>{data.location}</h3>
                      </div>

                      <div className="name">
                        <h3>{data.name}</h3>
                      </div>

                      <div className="description">
                        <p>{data.description}</p>
                      </div>
                    </div>

                    <div className="viewMore">
                      {/* <button className="">ดูเพิ่มเติม</button> */}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </PhotoProvider>
        </div>
      </div>
    </main>
  );
};

export default ProjectSlider;
